import React, { FC } from 'react'
import { PrintLayout } from 'components/Layout'
import { DepositHistoryDetailPrintTemplate } from 'components/Templates'
import { useSelector } from 'react-redux'
import { State } from 'index'

const DepositHistoryDetail: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const paths = pathname.split('/')
  const payoutId = pathname.split('/')[paths.length - 1]
  const title = '入金履歴'
  return (
    <PrintLayout title={title}>
      <DepositHistoryDetailPrintTemplate payoutId={payoutId} />
    </PrintLayout>
  )
}

export default DepositHistoryDetail
